import { Stack, Typography } from '@mui/material';
import { FC } from 'react';

import { LockerStatus, Piece, Workflow } from '@apiContract';
import InfoLine from 'src/components/InfoLine';
import { useSettings } from 'src/hooks/useSettings';
import { isPieceInLocker } from 'src/utils/piece';

type Props = {
  containerTitle?: string;
  piece: Piece;
};

const messages = {
  notAssigned: 'Location ID will be updated after item is assigned',
  isPlaced: 'Location cannot be changed when item is in locker',
  notSaved: 'Location ID will be updated after item is stored in a locker',
};

const getMessage = (piece: Piece, reservationFlow: boolean, containerTitle?: string) => {
  const isLocker = piece.workflow === Workflow.Lockers;
  const isPlaced = isLocker && isPieceInLocker(piece);
  switch (true) {
    case !containerTitle && !isLocker:
      return messages.notAssigned;

    case isPlaced:
      return messages.isPlaced;


    // copy/paste of case with same return to coresponde requrements table + more readable.
    // singe case of this contitons unreadable by human
    case isLocker && (!reservationFlow || (reservationFlow && !containerTitle)) && !isPlaced:
      return messages.notSaved;

    case isLocker &&
      reservationFlow &&
      piece.lockerState &&
      (piece.lockerState.status === LockerStatus.NotReady || piece.lockerState.status === LockerStatus.Pending):
      return messages.notSaved;

    default:
      return;
  }
};

const ContainerName: FC<Props> = ({ containerTitle, piece }) => {
  const { LockerReservationEnabled } = useSettings(['LockerReservationEnabled']) as Record<string, boolean>;

  const message = getMessage(piece, LockerReservationEnabled, containerTitle);

  return (
    <Stack>
      <Typography variant="overline" color="textSecondary">
        Location ID
      </Typography>
      <Typography variant="subtitle1">{containerTitle || '-'}</Typography>
      {message && <InfoLine text={message} />}
    </Stack>
  );
};

export default ContainerName;
